import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextPage } from "../../registration/staticPages/TextPage";
import { RegistrationFormResource } from "../../shared/types";
import { RenderRegistrationBlock } from "../RenderRegistrationBlock";

interface Props {
	registrationForm: RegistrationFormResource;
}

export const EmailGateWelcomeBackPage: FC<Props> = ({ registrationForm }) => {
	const { t } = useTranslation();

	return registrationForm.emailGateWelcomeBackBlockId ? (
		<RenderRegistrationBlock blockId={registrationForm.emailGateWelcomeBackBlockId} />
	) : (
		<TextPage
			headline={t("Welcome back!")}
			text={t("An email with your personal registration link has been sent to you.")}
		/>
	);
};
